import { HttpClient } from '@angular/common/http';
import {
  SaveAccountPropertiesParams,
  SaveRITEstimateForYearParams,
  GetRITEstimateForYearParams,
  AddAccountContactParams,
  GetTaxpayerContactsParams,
  GetAllTaxpayerAccountsByTypeParams,
  GetGroupTaxpayerAccountsForGroupParams,
  GetTaxpayerPoolGroupsParams,
  GetTaxpayerGroupsParams,
  GetGroupTaxpayerAccountsForGroupTypeParams,
  GetTaxpayerDetailsParams,
  GetTaxpayerAccountsForAdminParams,
  ITaxpayersAPI,
  EditTaxpayerDetailsParams,
  GetTaxpayerAccountsForAdminResponse,
  GetTaxpayerDetailsResponse,
  SaveAccountPropertiesResponse,
  SaveRITEstimateForYearResponse,
  GetRITEstimateForYearResponse,
  AddAccountContactResponse,
  GetTaxpayerContactsResponse,
  GetAllTaxpayerAccountsByTypeResponse,
  GetGroupTaxpayerAccountsForGroupResponse,
  GetTaxpayerPoolGroupsResponse,
  GetTaxpayerGroupsResponse,
  GetGroupTaxpayerAccountsForGroupTypeResponse,
  EditTaxpayerDetailsResponse,
} from './definitions';

export class TaxpayersAPI implements ITaxpayersAPI {
  private apiUrl: string;

  public constructor(private http: HttpClient, private baseUrl: string) {
    this.apiUrl = `${baseUrl}/taxpayers`;
  }

  public getTaxpayerAccountsForAdmin(
    params: GetTaxpayerAccountsForAdminParams,
  ) {
    const url = `${this.apiUrl}`;
    return this.http.get<GetTaxpayerAccountsForAdminResponse>(url);
  }

  public getTaxpayerDetails(params: GetTaxpayerDetailsParams) {
    const url = `${this.apiUrl}/${params.accountId}`;
    return this.http.get<GetTaxpayerDetailsResponse>(url);
  }

  public editTaxpayerDetails(params: EditTaxpayerDetailsParams) {
    const url = `${this.apiUrl}/${params.accountId}`;
    return this.http.patch<EditTaxpayerDetailsResponse>(url, params);
  }

  public getGroupTaxpayerAccountsForGroupType(
    params: GetGroupTaxpayerAccountsForGroupTypeParams,
  ) {
    const url = `${this.apiUrl}/${params.accountId}/group-type/${params.groupId}`;
    return this.http.get<GetGroupTaxpayerAccountsForGroupTypeResponse>(url);
  }

  public getTaxpayerGroups(params: GetTaxpayerGroupsParams) {
    const url = `${this.apiUrl}/${params.accountId}/group`;
    return this.http.get<GetTaxpayerGroupsResponse>(url);
  }

  public getTaxpayerPoolGroups(params: GetTaxpayerPoolGroupsParams) {
    const url = `${this.apiUrl}/${params.accountId}/group/pool`;
    return this.http.get<GetTaxpayerPoolGroupsResponse>(url);
  }

  public getGroupTaxpayerAccountsForGroup(
    params: GetGroupTaxpayerAccountsForGroupParams,
  ) {
    const url = `${this.apiUrl}/${params.accountId}/group/${params.groupId}`;
    return this.http.get<GetGroupTaxpayerAccountsForGroupResponse>(url);
  }

  public getAllTaxpayerAccountsByType(
    params: GetAllTaxpayerAccountsByTypeParams,
  ) {
    const url = `${this.apiUrl}/type/${params.typeId}`;
    return this.http.get<GetAllTaxpayerAccountsByTypeResponse>(url);
  }

  public getTaxpayerContacts(params: GetTaxpayerContactsParams) {
    const url = `${this.apiUrl}/${params.accountId}/contacts`;
    return this.http.get<GetTaxpayerContactsResponse>(url);
  }

  public addAccountContact(params: AddAccountContactParams) {
    const url = `${this.apiUrl}/add-account-contact`;
    return this.http.post<AddAccountContactResponse>(url, params);
  }

  public getRITEstimateForYear(params: GetRITEstimateForYearParams) {
    const url = `${this.apiUrl}/${params.accountId}/rit/${params.incomeYear}`;
    return this.http.get<GetRITEstimateForYearResponse>(url);
  }

  public saveRITEstimateForYear(params: SaveRITEstimateForYearParams) {
    const url = `${this.apiUrl}/${params.accountId}/rit/${params.incomeYear}`;
    return this.http.post<SaveRITEstimateForYearResponse>(url, params);
  }

  public saveAccountProperties(params: SaveAccountPropertiesParams) {
    const url = `${this.apiUrl}/${params.accountId}/save-account-properties`;
    return this.http.post<SaveAccountPropertiesResponse>(url, params);
  }
}
